import React, { useState } from "react";
import ReviseAnswerModal from "../../components/ReviseAnswerModal";
import SenderMessage from "../../components/SenderMessage";
import ReceiverMessage from "../../components/ReceiverMessage";

const ThreadMessages = ({ messages, thread }) => {
  const [showReviseModal, setShowReviseModal] = useState(false);

  const [reviseAnswerData, setReviseAnswerData] = useState({
    question: "",
    agent_response: "",
  });

  const reviseAnswer = idx => {
    let questionMessage = null;

    for (let i = idx - 1; i >= 0; i--) {
      if (messages[i].direction === "outgoing") {
        questionMessage = messages[i];
        break;
      }
    }

    setReviseAnswerData({
      agent_response: messages[idx]?.message,
      question: questionMessage?.message,
    });

    setShowReviseModal(true);
  };

  return (
    <>
      <div className="flex flex-col gap-6">
        {messages.map((message, index) =>
          Boolean(message.direction === "incoming") ? (
            <div key={index} className="flex justify-end">
              <SenderMessage
                message={message}
                thread={thread}
                onRevise={() => reviseAnswer(index)}
              />
            </div>
          ) : (
            <ReceiverMessage key={index} message={message} thread={thread} />
          )
        )}
      </div>

      <ReviseAnswerModal
        defaultValues={reviseAnswerData}
        open={showReviseModal}
        onClose={() => setShowReviseModal(false)}
      />
    </>
  );
};

export default ThreadMessages;
